import { ENV } from 'shared/helpers/env';

type SupportImpersonationConfig = {
  applicationOrigin: string;
  authOrigin: string;
  publicOrigin: string;
};

const PRODUCTION_SUPPORT_IMPERSONATION_CONFIG: SupportImpersonationConfig = {
  applicationOrigin: 'https://consumer.apps.opendoor.com',
  authOrigin: 'https://auth.apps.opendoor.com',
  publicOrigin: 'https://consumer.opendoor.com',
};
const STAGING_SUPPORT_IMPERSONATION_CONFIG: SupportImpersonationConfig = {
  applicationOrigin: 'https://consumer.apps-staging.opendoor.com',
  authOrigin: 'https://auth.apps-staging.opendoor.com',
  publicOrigin: 'https://consumer.simplersell.com',
};

const SUPPORT_IMPERSONATION_CONFIG_BY_ENV: Partial<Record<typeof ENV, SupportImpersonationConfig>> =
  {
    production: PRODUCTION_SUPPORT_IMPERSONATION_CONFIG,
    qa: STAGING_SUPPORT_IMPERSONATION_CONFIG,
    staging: STAGING_SUPPORT_IMPERSONATION_CONFIG,
  };

export const getSupportImpersonationConfig = (
  environment: typeof ENV,
): SupportImpersonationConfig | undefined => SUPPORT_IMPERSONATION_CONFIG_BY_ENV[environment];

export const isSupportApplicationUrl = (
  currentUrl: string,
  environment: typeof ENV = ENV,
): boolean =>
  new URL(currentUrl).origin ===
  SUPPORT_IMPERSONATION_CONFIG_BY_ENV[environment]?.applicationOrigin;
